import React, { useState } from "react";

export const ImageWithFallback = ({ src, alt, className, fallback }) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleError = () => {
    setError(true);
    setLoading(false);
  };

  const handleLoad = () => {
    setLoading(false);
  };

  if (error) {
    return (
      <div className={`bg-muted flex items-center justify-center ${className}`}>
        <div className="text-muted-foreground text-sm">
          {fallback || "Image non disponible"}
        </div>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <div className={`skeleton ${className}`} />
      )}
      <img
        src={src}
        alt={alt}
        className={`${className} ${loading ? 'hidden' : ''}`}
        onError={handleError}
        onLoad={handleLoad}
      />
    </>
  );
};
